import React from 'react';
import MobileMainLayout from '../../layout/MobileMainLayout';

const FridgeBottle = () => {
  return (
    <MobileMainLayout title="FridgeBottle" link="javascript:;">
      Working on it...
      {/* <AccessoriesBanner />

      <div className='mb-3'>
        <ShopByCategoryAccessories title="Trending Accessories" />
      </div> */}
    </MobileMainLayout>
  );
};

export default FridgeBottle;
